import styled from "styled-components";

const StyledBuildInAppContent = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    position: absolute;
`

export default StyledBuildInAppContent